var e=e=>e.charAt(0).toUpperCase()+e.slice(1);export{e as capitalize};
//# sourceMappingURL=capitalize.js.map
